import { useState, useEffect } from 'react';
import { API_CONFIG } from './../config'; 

const PAYMENTITEMS = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.PAYMENTITEMS}`;


const UsePaymentItems = () => {
    const [paymentItems, sePpayemntItems] = useState([]);
    const [paidItemLoading, setPaidItemLoading] = useState(true);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await fetch(PAYMENTITEMS);
                if (!response.ok) throw new Error('Network response was not ok');

                const data = await response.json();
                if (data.success) {
                    sePpayemntItems(data.data || []);
                }
            } catch (err) {
                console.error("Fetch users error:", err);
            } finally {
                setPaidItemLoading(false);
            }
        };
        fetchUsers();
    }, []);

    // Returning data and loading state just like your book example
    return { paymentItems, paidItemLoading };
};

export default UsePaymentItems;